import ga4 from "@/lib/tracking/ga4Core";

export const trackRequestFinancing = ({ source, position = "top" }) => {
  const eventName = "request_financing";
  const eventParams = {
    source,
    position,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};
